import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import UiIcon from 'ui-components/ui-icon/UiIcon';
import { Link } from 'react-router-dom';
import { usePermission } from 'hooks';
import ProfileMenuVersion from './ProfileMenuVersion';
import { StyledDesktopPopover } from './DesktopPopover.styles';

export const DesktopPopover = ({ avatar, user, logout, close }) => {
  const { t } = useTranslation();
  const { userPermission } = usePermission();

  // پرمیشن جهت دسترسی به پشتیبانی
  const { permission: permi_admin_support } = useMemo(
    () => userPermission('FrontEnd', 'ticketManagement'),
    [userPermission]
  );

  return (
    <StyledDesktopPopover>
      <div className='desktop-size-modal'>
        <div className='info flex'>
          <img className='avatar' src={avatar} />
          <span className='label'>
            {user?.name} {user?.last_name || ''}
          </span>
        </div>
        <hr className='hr m-0' />
        <Link to='/settings' className='section flex' onClick={close}>
          <UiIcon icon='ri-settings-3-line mr-0' color='#9CAEBB' size={20} />
          <span className='label'>{t('layout:userAccountSettings')}</span>
        </Link>
        <hr className='hr m-0' />
        {!permi_admin_support && (
          <>
            <Link to='/support' className='section flex' onClick={close}>
              <UiIcon
                icon='ri-customer-service-2-line mr-0'
                color='#9CAEBB'
                size={20}
              />
              <span className='label'>{t('support:pageTitle')}</span>
            </Link>
            <hr className='hr m-0' />
          </>
        )}

        <Link to='/academy' className='section flex' onClick={close}>
          <UiIcon icon='ri-video-line 1' color='#9CAEBB' size={20} />
          <span className='label'>{t('academy:academy')}</span>
        </Link>
        <hr className='hr m-0' />
        <div className='section flex' onClick={logout}>
          <UiIcon icon='ri-logout-box-r-line mr-0' color='#9CAEBB' size={20} />
          <span className='label'>{t('users:logout')}</span>
        </div>
        <hr className='hr m-0' />
        <ProfileMenuVersion close={close} />
      </div>
    </StyledDesktopPopover>
  );
};

DesktopPopover.propTypes = {
  avatar: PropTypes.string,
  user: PropTypes.object,
  logout: PropTypes.func,
  close: PropTypes.func,
};
